export const PathConstants = {
  HOME: "/",
  DICTIONARIES: "/dictionaries",
  LOGIN: "/login",
  operationOutcomes: "/operationOutcomes",
  USERS: "/users",
  MISMATCHES: "/mismatches",
};
